import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'biz-package-visualizer-breadcrumb',
  templateUrl: './package-visualizer-breadcrumb.component.html',
  styleUrls: ['./package-visualizer-breadcrumb.component.scss']
})
export class PackageVisualizerBreadcrumbComponent implements OnInit, OnChanges {

  @Input() pathList: IPackageNavigation[];
  @Output() onNavigate = new EventEmitter<string>();

  constructor(private _translateService: TranslateService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.pathList.length > 0)
      this.changeType();
  }

  changeType() {
    this.pathList.forEach(path => {
      if (path.displayName.toLowerCase() === 'stakeholdersentencecontext')
        path.displayName = this._translateService.instant('TYPE.CONTEXT');
      if (path.displayName.toLowerCase() === 'stakeholder')
        path.displayName = this._translateService.instant('TYPE.PERSONA');
    });
  }

  pathNavigation(id: string) {
    this.onNavigate.emit(id);
  }

}
